/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GroupContractSubscriberDto
 */
export interface GroupContractSubscriberDto {
    /**
     * 
     * @type {string}
     * @memberof GroupContractSubscriberDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractSubscriberDto
     */
    name: string;
    /**
     * LEGAL = personne morale, PHYSICAL = personne physique
     * @type {string}
     * @memberof GroupContractSubscriberDto
     */
    type: GroupContractSubscriberDtoTypeEnum;
    /**
     * SIRET (legal) or other identifier (physical)
     * @type {string}
     * @memberof GroupContractSubscriberDto
     */
    identifier?: string;
}


/**
 * @export
 */
export const GroupContractSubscriberDtoTypeEnum = {
    Legal: 'LEGAL',
    Physical: 'PHYSICAL'
} as const;
export type GroupContractSubscriberDtoTypeEnum = typeof GroupContractSubscriberDtoTypeEnum[keyof typeof GroupContractSubscriberDtoTypeEnum];


/**
 * Check if a given object implements the GroupContractSubscriberDto interface.
 */
export function instanceOfGroupContractSubscriberDto(value: object): value is GroupContractSubscriberDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GroupContractSubscriberDtoFromJSON(json: any): GroupContractSubscriberDto {
    return GroupContractSubscriberDtoFromJSONTyped(json, false);
}

export function GroupContractSubscriberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupContractSubscriberDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'type': json['type'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
    };
}

export function GroupContractSubscriberDtoToJSON(json: any): GroupContractSubscriberDto {
    return GroupContractSubscriberDtoToJSONTyped(json, false);
}

export function GroupContractSubscriberDtoToJSONTyped(value?: GroupContractSubscriberDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
        'identifier': value['identifier'],
    };
}

